export const errorConstants = {
    "account_exists": "An account already exists with that email address or phone number. Please use a different email or phone number or reset your password."
}